import { Menu, X } from 'lucide-react';
import { useTranslation } from '../hooks';
import LanguageSwitcher from './LanguageSwitcher';

const Header = ({ activeSection, isMenuOpen, setIsMenuOpen, scrollToSection }) => {
  const { t } = useTranslation();

  const navItems = [
    { label: t.nav.home, id: 'home' },
    { label: t.nav.services, id: 'services' },
    { label: t.nav.portfolio, id: 'portfolio' },
    { label: t.nav.process, id: 'process' },
    { label: t.nav.about, id: 'about' },
    { label: t.nav.history, id: 'history' },
    { label: t.nav.testimonials, id: 'testimonials' },
    { label: t.nav.faq, id: 'faq' },
    { label: t.nav.contact, id: 'contact' }
  ];

  return (
    <nav className="fixed top-0 w-full bg-black/90 backdrop-blur-md z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 overflow-hidden rounded bg-white">
              <img
                src="/images/logo.jpg"
                alt="M.A CONCEPT"
                className="w-full h-full object-cover"
              />
            </div>
            <span className="text-white text-xl font-light tracking-wider">M.A CONCEPT&IMMO</span>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className={`text-white hover:text-gray-300 transition-colors text-sm tracking-wide ${
                  activeSection === item.id ? 'border-b border-white' : ''
                }`}
              >
                {item.label}
              </button>
            ))}

            {/* Language Switcher - Desktop */}
            <LanguageSwitcher />
          </div>

          {/* Mobile: Language Switcher + Menu Button */}
          <div className="md:hidden flex items-center space-x-3">
            <LanguageSwitcher />
            <button
              className="text-white p-1"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-black border-t border-gray-800">
          <div className="px-4 pt-2 pb-3 space-y-1">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="block px-3 py-2 text-base font-medium text-white hover:text-gray-300 w-full text-left"
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Header;
